import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { DownloadOutlined } from "@ant-design/icons";
import announcementdetail_icon from "@/images/service/announcementdetail_icon.png";
import "./index.less";
import { serviceApi } from "@/apis";
import { Spin, message } from "antd";
import { downloadFile } from "@/utils";
import { useUserInfo } from "@/model";

const AnnouncementDetail = () => {
  const location = useLocation();
  const userInfo = useUserInfo();
  const [loading, setLoading] = useState(false);
  const [detailInfo, setDetailInfo] = useState<NoticeDetail>();

  useEffect(() => {
    const id = location.state?.id;
    if (id && userInfo.curUserInfo) {
      setLoading(true);
      serviceApi
        .getNoticeDetail({
          id,
        })
        .then((res) => {
          setDetailInfo(res);
        })
        .catch((err) => {
          message.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
      serviceApi
        .NoticeReadRecord({
          account: userInfo.curUserInfo.userAccount,
          customerCode: userInfo.curUserInfo.customerCode,
          noticeId: id,
        })
        .catch((err) => {
          message.error(err);
        });
    }
  }, [location, userInfo.curUserInfo]);

  const downLoad = (id: string, name: string) => {
    if (id) {
      downloadFile(
        `/crm-venus/v1/venus/files/download/${id}.id`,
        name || "附件"
      );
    }
  };

  return (
    <div className="announcement-detail-wrapper">
      <div className="center-main-title detail-title">
        <img src={announcementdetail_icon} alt="" />
        <h3>公告详情</h3>
      </div>
      <Spin spinning={loading}>
        <div className="detail-content-wrapper">
          <h2>{detailInfo?.title}</h2>
          <p className="time">{detailInfo?.createTime}</p>
          <div
            className="detail-info"
            dangerouslySetInnerHTML={{ __html: detailInfo?.content || "" }}
          ></div>
          {detailInfo?.fileList ? (
            <div className="detail-item-wrapper">
              <div className="detail-appendix">
                {detailInfo.fileList.map(
                  ({ id, fileCode, originalFileName }) => (
                    <div
                      className="appendix-item"
                      key={id}
                      onClick={() => downLoad(fileCode, originalFileName)}
                    >
                      <span> {`${originalFileName || "附件"}`}</span>
                      <DownloadOutlined />
                    </div>
                  )
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Spin>
    </div>
  );
};

export default AnnouncementDetail;
